import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/first-internal-transaction-plan/page.tsx");
